// extracted by mini-css-extract-plugin
export var quantityInput = "_ou-0";